import React from 'react'
import { Helmet } from 'react-helmet'

export default function ForgotPasswordSEO() {
  return (
        <Helmet>
            <title>Forgot Password &#8226; Wheels Repository</title>
            <meta name="description" content="Forgot Password - whrepo.com" />
            <link rel="canonical" href="https://whrepo.com/forgot-password/" />
        </Helmet>
  )
}